<template>
  <div class="banner-section">
    <!-- 顶部装饰 -->
    <div class="top-decoration" @click="goToPage" v-if="config.decorationImage">
      <img 
        :src="config.decorationImage" 
        alt="客服"
        class="decoration-img"
      />
    </div>
    
    <!-- 主 Banner -->
    <div class="main-banner" v-if="config.bannerImage">
      <img 
        :src="config.bannerImage" 
        alt="头图"
        class="banner-img"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BannerSection',
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    goToPage() {
      if (this.config.clickUrl) {
        window.location.href = this.config.clickUrl
      }
    }
  }
}
</script>

<style lang="less" scoped>
.banner-section {
  position: relative;
  width: 100%;
}

.top-decoration {
  position: fixed;
  top: 10%;
  right: 0;
  z-index: 10;
  cursor: pointer;

  .decoration-img {
    width: 0.7rem;
    height: auto;
  }
}

.main-banner {
  width: 100%;
  
  .banner-img {
    width: 100%;
    height: auto;
    display: block;
  }
}
</style>
